import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

class AddAcceptLanguageHttpInterceptor {
    constructor(injector) {
        this.injector = injector;
    }
    intercept(request, next) {
        const translate = this.injector.get(TranslateService);
        if (translate && translate.currentLang) {
            return next.handle(request.clone({
                headers: request.headers.set('Accept-Language', translate.currentLang),
            }));
        }
        return next.handle(request);
    }
}
AddAcceptLanguageHttpInterceptor.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: AddAcceptLanguageHttpInterceptor, deps: [{ token: i0.Injector }], target: i0.ɵɵFactoryTarget.Injectable });
AddAcceptLanguageHttpInterceptor.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: AddAcceptLanguageHttpInterceptor, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: AddAcceptLanguageHttpInterceptor, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i0.Injector }]; } });

/**
 * Generated bundle index. Do not edit.
 */

export { AddAcceptLanguageHttpInterceptor };
